import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
  selector: 'cs-skeleton',
  templateUrl: 'cs-skeleton.html',
  host: { 'class': 'skeleton' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsSkeletonComponent {
  @Input() width: string;
}
